var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgComplianceIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1114_5851",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 4,
    y: 3,
    width: 16,
    height: 18
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.661 3H4.5V21H19.661V3Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1114_5851)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.1403 3C12.5093 3.15819 12.7574 3.48833 13.0642 3.73805C14.3838 4.81206 16.0065 5.41996 17.6957 5.56916C18.0752 5.60302 18.5175 5.5644 18.8755 5.60831C19.6173 5.69931 19.433 6.42255 19.4524 6.96114C19.6262 11.6958 19.5346 16.4437 15.3344 19.4117C14.5272 19.9821 13.217 20.6963 12.2717 20.963C11.8524 21.0809 11.5142 20.89 11.1206 20.7339C9.28382 20.0038 7.58156 18.8366 6.43468 17.1976C4.37228 14.2517 4.42672 10.4625 4.54921 6.99712C4.56858 6.45165 4.37647 5.7009 5.12605 5.60884C5.48409 5.56493 5.92641 5.60302 6.30591 5.56969C8.00346 5.41943 9.60993 4.81418 10.9374 3.73858C11.2441 3.48992 11.4959 3.16137 11.8613 3.00053L12.1403 3ZM14.5309 9.2335L11.1405 12.501L11.0232 12.4545L9.54555 10.7805L8.58815 11.6424L10.66 13.948C10.961 14.1671 11.2316 14.1068 11.5137 13.8962L15.3982 10.1811C15.4213 10.1546 15.4119 10.1382 15.3982 10.1112C15.3846 10.0842 15.0365 9.71336 14.979 9.65305C14.9214 9.59273 14.578 9.22556 14.5309 9.2335Z",
    fill: "#FF9355"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgComplianceIcon);
export default __webpack_public_path__ + "static/media/compliance-icon.fc8ccc521350515f4d12ba699241f8cb.svg";
export { ForwardRef as ReactComponent };